// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ni6t","largestCol":"styles_largestCol__16_OZ","smallestCol":"styles_smallestCol__h3YUt"};